import { Select } from "antd";
import { useTranslation } from "react-i18next";
import OrderCard from "./OrderCard";
import EmptyState from "./EmptyState";

import filledDropdownArrowIcon from "../../assets/icons/filled-dropdown-arrow.svg";

export default function OrdersTab({
  orderStatusFilter,
  onFilterChange,
  orders,
  hasAnyOrders,
  getColClass,
}) {
  const { t } = useTranslation();

  return (
    <div className="buy-and-supply__pending-orders-holder row m-0">
      {hasAnyOrders && (
        <div className="col-12 px-0 buy-supply-2026-orders-filter">
          <Select
            className="buy-supply-2026-orders-filter__select"
            value={orderStatusFilter}
            onChange={onFilterChange}
            suffixIcon={
              <img
                src={filledDropdownArrowIcon}
                alt=""
                className="d-block img-fluid"
              />
            }
            options={[
              { value: "all", label: t("buyAndSupply2026.filterAll") },
              { value: 1, label: t("buyAndSupply2026.statusPending") },
              { value: 2, label: t("buyAndSupply2026.statusAccepted") },
              { value: 3, label: t("buyAndSupply2026.statusRejected") },
              { value: 4, label: t("buyAndSupply2026.statusCollected") },
            ]}
            popupMatchSelectWidth={false}
          />
        </div>
      )}

      {orders?.length > 0 ? (
        orders.map((order, index) => (
          <div key={order.id} className={getColClass(index)}>
            <OrderCard data={order} />
          </div>
        ))
      ) : (
        <div className="col-12">
          <EmptyState data="orders" />
        </div>
      )}
    </div>
  );
}
